export default {
  tabList: [
    {
      title: "全部",
      key: 1,
      img: require("@/basa/assets/images/gg1.png")
    },
    {
      title: "物资",
      key: 2,
      img: require("@/basa/assets/images/gg2.png")
    },
    {
      title: "设备",
      key: 3,
      img: require("@/basa/assets/images/gg3.png")
    },
    {
      title: "其他服务",
      key: 4,
      img: require("@/basa/assets/images/gg4.png")
    },
    {
      title: "工程分包",
      key: 5,
      img: require("@/basa/assets/images/gg5.png")
    }
    // {
    //   title: "工程服务(建设中)",
    //   key: 6,
    //   img: require("@/basa/assets/images/gg6.png")
    // }
  ]
};
